import { FC, useMemo } from 'react';
import { ErrorResponse, isRouteErrorResponse } from 'react-router';

import KobaiLogo from 'assets/images/logos/Kobai_logo_secondary_400.svg';
import ErrorIcon from 'assets/images/error/error_icon.svg';
import { ROUTE_ERROR_TEXT } from './constants/RouteError.constants';

type Props = {
  error: ErrorResponse | Error | unknown;
  isChunkError: boolean;
};

const RouteErrorPageContent: FC<Props> = ({ error, isChunkError }) => {
  const errorMessage = useMemo(() => {
    if (isRouteErrorResponse(error)) {
      return error.statusText;
    } else if (error instanceof Error) {
      return error.message;
    } else if (typeof error === 'string') {
      return error;
    } else {
      console.error(error);
      return ROUTE_ERROR_TEXT.default;
    }
  }, [error]);

  return (
    <div className="tw:max-w-[800px] tw:mx-auto tw:mt-8 tw:text-center tw:bg-primary-100 tw:text-secondary-400">
      <img src={KobaiLogo} alt="Kobai Logo" className="tw:mx-auto tw:mb-4 tw:block" />
      <img src={ErrorIcon} alt="Error Icon" className="tw:mx-auto tw:mt-[100px] tw:mb-4 tw:block" />
      <div className="tw:text-3xl">
        {!isChunkError && errorMessage}
        {isChunkError && (
          <section>
            <div>{ROUTE_ERROR_TEXT.chunkLoadError.actionText}</div>
            <div className="tw:mt-4 tw:text-xl">
              {ROUTE_ERROR_TEXT.chunkLoadError.subActionText}
            </div>
          </section>
        )}
      </div>
    </div>
  );
};

export default RouteErrorPageContent;
